var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10.5C19.25 5.66751 15.3325 1.75 10.5 1.75C5.66751 1.75 1.75 5.66751 1.75 10.5C1.75 15.3325 5.66751 19.25 10.5 19.25C15.3325 19.25 19.25 15.3325 19.25 10.5Z",
    fill: "#1275B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38662 6.55759C8.38662 7.14169 7.88031 7.61519 7.25581 7.61519C6.63128 7.61519 6.125 7.14169 6.125 6.55759C6.125 5.9735 6.63128 5.5 7.25581 5.5C7.88031 5.5 8.38662 5.9735 8.38662 6.55759Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28125 8.39258H8.21424V14.25H6.28125V8.39258Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3236 8.39265H9.39062V14.2501H11.3236C11.3236 14.2501 11.3236 12.4061 11.3236 11.2531C11.3236 10.5611 11.5599 9.86602 12.5027 9.86602C13.5682 9.86602 13.5619 10.7716 13.5569 11.4733C13.5504 12.3903 13.5659 13.3263 13.5659 14.2501H15.4989V11.1586C15.4825 9.18471 14.9681 8.27515 13.2759 8.27515C12.271 8.27515 11.6481 8.7314 11.3236 9.14415V8.39265Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinPublic);
export default __webpack_public_path__ + "static/media/linkedinPublic.a5d599ddbed4b0a4e0f0f09a7e30f675.svg";
export { ForwardRef as ReactComponent };